/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */

import { Dictionary } from '../types/types';

/*
 * Coach Amigo React Signup
 * https://github.com/facebook/react-native
 *
 * @description This Library works like the Worpress actions and hooks
 * @author Virgial Berveling
 * @version 3.0.0
 */
const allActions = () => {
   const ACTIONS: Dictionary = {};
   return () => ACTIONS;
};
const getAllActions = allActions();

const allFilters = () => {
   const FILTERS: Dictionary = {};
   return () => FILTERS;
};
const getAllFilters = allFilters();

const __DEV__ = process.env.NODE_ENV !== 'production';
const suppressed_logs: Array<string> = [];
let SUPPRESS_ALL_LOGS = !__DEV__;
/* ACTIONS */
export const suppress_all_logs = (bool: boolean = true) => {
   SUPPRESS_ALL_LOGS = bool;
};
export const suppress_log = (name: string) => {
   suppressed_logs.push(name);
};
export const remove_action = (name: string, id?: number): boolean => {
   const ACTIONS = getAllActions();
   if (ACTIONS[name]) {
      if (id && ACTIONS[name][id]) {
         delete ACTIONS[name][id];
         console_log('ACTION REMOVED:', name, id);
      } else if (!id) {
         delete ACTIONS[name];

         console_log('ALL ACTIONS REMOVED:', name);
      }
      return true;
   } else {
      return false;
   }
};

export const add_action = (name: string, F: Function, args: any = null, given_id?: number): number | undefined => {
   const ACTIONS = getAllActions();
   if (!ACTIONS[name]) ACTIONS[name] = [];

   const id= given_id ? given_id : ACTIONS[name].length;

   ACTIONS[name][id] = { args: args, F: F };
   console_log('ACTION ADDED:', name, id);
   // return calback id
   return id;
};

export const do_actions = (name: string, direct_args?: object): any | boolean => {
   const ACTIONS = getAllActions();

   if (ACTIONS[name] && Array.isArray(ACTIONS[name])) {
      const once: Array<number> = [];
      ACTIONS[name].map((A: Dictionary, id: number) => {
         let args: Dictionary | null = A.args;
         const F: Function = A.F;
         if (direct_args) args = direct_args;
         F(args);
         console_log('ACTION DO:', name, id, direct_args);
         if (args && args.once) once.push(id);
      });
      if (once.length > 0) {
         once.map((id: number) => remove_action(name, id));
      }
      return true;
   } else {
      return false;
   }
};

/* FILTERS */

export const remove_filter = (name: string, id?: number): boolean => {
   const FILTERS = getAllFilters();

   if (id && FILTERS[name]) {
      if (FILTERS[name][id]) {
         delete FILTERS[name][id];
         console_log('FILTER REMOVED:', name, id);
      } else if (!id) {
         delete FILTERS[name];
         console_log('ALL FILTERS REMOVED:', name);
      }
      return true;
   } else {
      return false;
   }
};

export const add_filter = (name: string, F: Function, args: any = null, id?: number): string | number => {
   const FILTERS = getAllFilters();

   if (!FILTERS[name]) FILTERS[name] = [];

   if (!id) {
      FILTERS[name].push({ F: F, args: args });
      id = FILTERS[name].length - 1;
   } else {
      FILTERS[name][id] = { F: F, args: args };
   }
   console_log('FILTER ADDED:', name, id);

   // return calback id
   return id;
};

export const apply_filters = (name: string, value: any): any => {
   const FILTERS = getAllFilters();
   if (FILTERS[name] && Array.isArray(FILTERS[name])) {
      const once: Array<number> = [];
      FILTERS[name].map((A: Dictionary, id: number) => {
         value = A.F(A.args, value, id);
         console_log('FILTERS APPLIED:', name, id);
         if (A.args && A.args.once) once.push(id);
      });
      if (once.length > 0) {
         once.map((id: number) => remove_filter(name, id));
      }
   }
   return value;
};

const console_log = (str: string, name?: string, id?: number, args?: any) => {
   if (!SUPPRESS_ALL_LOGS && name && !suppressed_logs.includes(name)) console.log(str, name, id, args);
};
